import {createConfirmation} from 'react-confirm';
import Confirm from './Confirm';

export default (confirmation, options = {}) => createConfirmation(Confirm)({confirmation, options});
